import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonIcon,
  IonRow,
} from '@ionic/react';
import { mapOutline } from 'ionicons/icons';
import { ICDRTEvent } from '../../../lib/models';

const EventCard = ({ cdrtEvent }: { cdrtEvent: ICDRTEvent }) => {
  return (
    <IonCard key={cdrtEvent.id}>
      <img
        src={
          cdrtEvent.media?.data?.attributes?.url ||
          'https://dummyimage.com/640x360/fff/aaa'
        }
        alt={`${cdrtEvent.title}`}
      />
      <IonCardHeader>
        <IonCardTitle className='font-bold'>{cdrtEvent.title}</IonCardTitle>
        <IonCardSubtitle>
          <div className='flex justify-between items-center'>
            <div>
              {cdrtEvent?.startDate && (
                <span>
                  Inizio:{' '}
                  <span className='font-bold'>
                    {new Date(cdrtEvent?.startDate).toLocaleDateString()}
                  </span>
                </span>
              )}
              {cdrtEvent?.startDate && cdrtEvent?.endDate && ' - '}
              {cdrtEvent?.endDate && (
                <span>
                  Fine:{' '}
                  <span className='font-bold'>
                    {new Date(cdrtEvent?.endDate).toLocaleDateString()}
                  </span>
                </span>
              )}
            </div>
            <div className='flex items-center'>
              {cdrtEvent.address && (
                <IonIcon
                  aria-hidden='true'
                  icon={mapOutline}
                  className='h-5 w-5'
                />
              )}
            </div>
          </div>
        </IonCardSubtitle>
      </IonCardHeader>
      <IonCardContent>
        <p dangerouslySetInnerHTML={{ __html: cdrtEvent.extract }}></p>
      </IonCardContent>
      <IonRow>
        <IonCol className='flex justify-end'>
          <IonButton routerLink={`/events/${cdrtEvent.id}`}>Dettagli</IonButton>
        </IonCol>
      </IonRow>
    </IonCard>
  );
};

export default EventCard;
